export enum ActionType {
  KSM_REQUIREMENT_DETAILS_BY_PID = "KSM_REQUIREMENT_DETAILS_BY_PID",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}

export interface IKSMRequirementProjectDetailsByPid {
  type: ActionType.KSM_REQUIREMENT_DETAILS_BY_PID;
  payload: any;
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = IKSMRequirementProjectDetailsByPid | IResetReduxState;
